import { FC, useEffect, useState } from "react";
import { Parameter } from "../../../types/Parameter";
import { ColumnDirective, ColumnsDirective, Edit, Grid, GridComponent, Inject, Resize } from "@syncfusion/ej2-react-grids";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { Container, Row } from "react-grid-system";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import { NumericTextBoxComponent, TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import { DateTimePickerComponent } from "@syncfusion/ej2-react-calendars";

interface IParametersModal {
  open: boolean;
  title: string;
  jobNumber: string;
  onUpdateParameters: (jobNumber: string, parameters: Parameter[]) => void;
  onClose: () => void;
  parameters: Parameter[];
}

export const ParametersModal: FC<IParametersModal> = ({
  open,
  onUpdateParameters,
  onClose,
  title,
  parameters,
  jobNumber,
}) => {
  const [params, setParams] = useState<Parameter[]>(parameters);
  const [errors, setErrors] = useState("");

  useEffect(() => {
    if (params) {
      validate(params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buttons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
        disabled: errors && errors.length > 0 ? true : false,
      },
      click: () => {
        onUpdateParameters(jobNumber, params);
      },
    },
    {
      buttonModel: {
        content: "Cancel",
        cssClass: "e-flat",
      },
      click: () => {
        onClose();
      },
    },
  ];

  const firstPosition = { X: 400, Y: 200 };

  let grid: Grid | null;

  /* const load = (): void => {
    let instance = (document.getElementById("GridCheckList") as any)
      .ej2_instances[0]; //(document.('GridCheckList') as HTMLElement).ej2_instances[0];
    console.log(`loading ${grid} ${instance}`);
    if (instance) {
      instance.element.addEventListener("mouseup", function (e: any) {
        if ((e.target as HTMLElement).classList.contains("e-rowcell")) {
          if (instance.isEdit) instance.endEdit();
          let index: number = parseInt(
            (e.target as HTMLElement).getAttribute("Index") ?? ""
          );
          instance.selectRow(index);
          instance.startEdit();
        }
      });
    }
  };

  const onActionComplete = (args: EditEventArgs) => {
    console.log(`onActionComplete ${args.requestType}`);
    if (args.requestType === "refresh" || args.requestType === "save") {
      validate(items);
    }
  }; */

  const validate = (parameters: Parameter[] | undefined) => {
    console.log(`onValidate  ${JSON.stringify(parameters)}`);
    if (parameters?.some((parameter) => parameter.value === undefined ||  parameter.value === null)) {
      setErrors("Please enter all parameters.");
    } else {
      setErrors("");
    }
  };

  const conditionTemplate = (props: any) => {
    return (
      <div>
        {props.type === 'string' ?
          <TextBoxComponent
            id="checkTest"
            value={props.value}
            onChange={(args: any) => {
              const updatedItems = [...params.map((parameter) => {
                if (parameter.name === props.name) {
                  parameter.value = args.value;
                }
                return parameter;
              })];
              console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
              validate(updatedItems);
              setParams(updatedItems);
            }}
          /> : <></>}
        {props.type === 'number' ?
          <NumericTextBoxComponent
            id="checkTest"
            value={props.value}
            change={(args: any) => {
              const updatedItems = [...params.map((parameter) => {
                if (parameter.name === props.name) {
                  parameter.value = args.value;
                }
                return parameter;
              })];
              console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
              validate(updatedItems);
              setParams(updatedItems);
            }}
          /> : <></>}
        {props.type === 'dateTime' ?
          <DateTimePickerComponent 
            id="dateTime"
            value={props.value}
            onChange={(args: any) => {
              const updatedItems = [...params.map((parameter) => {
                if (parameter.name === props.name) {
                  parameter.value = args.value;
                }
                return parameter;
              })];
              console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
              validate(updatedItems);
              setParams(updatedItems);
            }}
          /> : <></>}
        {props.type === 'boolean' ?
        <CheckBoxComponent
          id="checkTest"
          checked={props.value === true}
          onChange={(args: any) => {
            const updatedItems = [...params.map((parameter) => {
              if (parameter.displayName === props.displayName) {
                parameter.value = args.target.checked;
              }
              return parameter;
            })];
            console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
            validate(updatedItems);
            setParams(updatedItems);
          }}
        /> : <></>}
      </div>
    );
  };

 
  return (
    <DialogComponent
      width="400px"
      close={onClose}
      header={`${title}`}
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      <div className="dialogContent">
        <Container fluid>
          <Row align="stretch">
            <GridComponent
              dataSource={params}
              id="GridCheckList"
              //allowPaging={true}
              allowResizing={true}
              gridLines="Both"
              ref={(g : GridComponent) => (grid = g)}
              //editSettings={editSettings}
              //load={load}
              //actionComplete={onActionComplete}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="displayName"
                  headerText="Info"
                  type="string"
                  isPrimaryKey={true}
                />
                <ColumnDirective
                  field="value"
                  headerText="Value"
                  template={conditionTemplate}
                />
              </ColumnsDirective>
              <Inject services={[Edit, Resize]} />
            </GridComponent>
          </Row>
          <Row align="stretch">
            <h6 style={{ color: "red" }}>{errors}</h6>
          </Row>
        </Container>
      </div>
    </DialogComponent>
  );
};
